/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useSwipeable } from 'react-swipeable';
import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { useLocalizedSanityNewsBondsByUrlIdWithoutInvalid } from '../../../../../../../../../../../../../../../../../../../../sanity';
import { useNewsBondCurrentPageHandlers } from '../../../../context';

const style: ouiStyle.InStyleWithMediaQueries = {
  lines: 'full',
  widthLines: 'full',
  backgroundColor: ouiStyle.Constants.Colors.fade,
  position: 'relative',
};

const css = ouiStyle.mediaQuery(ouiStyle.makeCss(style));

export const BondMapperMobileContainer = (props: React.PropsWithChildren<{}>) => {
  const {
    children,
  } = props;
  const {
    data,
  } = useLocalizedSanityNewsBondsByUrlIdWithoutInvalid();
  const [, setCurrentPage] = useNewsBondCurrentPageHandlers();
  const handlers = useSwipeable({
    onSwipedLeft: () => setCurrentPage((page) => {
      const next = page + 1;
      if (next > (data?.length ?? 1) - 1) {
        return page;
      }
      return next;
    }),
    onSwipedRight: () => setCurrentPage((page) => {
      const next = page - 1;
      if (next < 0) {
        return page;
      }
      return next;
    }),
    swipeDuration: 500,
    preventScrollOnSwipe: true,
    trackMouse: true,
  });
  if (data == null) {
    return null;
  }
  return (
    <div
      {...handlers}
      css={css}
    >
      {children}
    </div>
  );
};
